// AC1: true in a browser tab where a Car Wash Minder support login has opened a customer account.
export const SUPPORT_ORG_KEY = 'supportSelectedOrgId';

export function supportSessionOrgId() {
  try { return sessionStorage.getItem(SUPPORT_ORG_KEY) || null; } catch { return null; }
}

export const inSupportSession = () => supportSessionOrgId() !== null;
